import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { RecipeFormValues } from '@ordersnproducts/modules/order-builder/modules/retail-specification/models/form-values';

import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import {
  ActionTypes,
  Actions,
} from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/open-platform/forms-snapshots.actions';

export interface FormSnapshot {
  index: number;
  snapshot: RecipeFormValues;
}

export interface State extends EntityState<FormSnapshot> {
  selectedFormSnapshot: number | null;
}

export const adapter: EntityAdapter<FormSnapshot> = createEntityAdapter<FormSnapshot>({
  selectId: (_formSnapshot: FormSnapshot) => _formSnapshot.index,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedFormSnapshot: null,
});

export function reducer(state = initialState, action: Actions | OrderBuilderActions): State {
  switch (action.type) {
    case ActionTypes.ADD_SNAPSHOT: {
      return adapter.addOne(
        {
          index: action.payload.formIndex,
          snapshot: action.payload.formSnapshot,
        },
        state,
      );
    }
    case ActionTypes.UPDATE_SNAPSHOT: {
      return adapter.updateOne(
        {
          id: action.payload.formIndex,
          changes: {
            snapshot: action.payload.formSnapshot,
          },
        },
        state,
      );
    }
    case ActionTypes.CLEAN_SNAPSHOT: {
      return adapter.removeOne(action.payload.formIndex, state);
    }
    case ActionTypes.CLEAN_ALL_SNAPSHOTS:
    case RESET_BUILDER: {
      return adapter.removeAll(state);
    }
    default: {
      return state;
    }
  }
}
